import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  IconCardLinkSupportPunish,
  IconCardLinkSupportQuestion,
  IconCardLinkSupportService,
  IconNopPhatNguoi
} from '../../../assets/icons'
import BaseTitle from '../../BasicComponent/BaseTitle'
import BaseBottomSheetPopup from '../../BasicComponent/BaseBottomSheetPopup'
import SupportCenterPopup from '../../BasicComponent/SupportCenterPopup'
import './index.scss'
import { PATH } from '../../../constants/router'

export default function CardIconsLinkSupport() {
  const history = useHistory()
  const [isOpenSupportCenterPopup, setIsOpenSupportCenterPopup] = useState(false)
  const [isOpenPunishPopup, setIsOpenPunishPopup] = useState(false)
  const icons = [
    {
      key: 1,
      icon: <IconCardLinkSupportQuestion />,
      link: '',
      onClick: () => {
        history.push(PATH.TRAFFIC_FINE_FAQ)
      },
      text: 'Các câu hỏi thường gặp'
    },
    {
      key: 2,
      icon: <IconCardLinkSupportPunish />,
      link: '',
      onClick: () => {
        setIsOpenPunishPopup(true)
      },
      text: 'Nộp phạt nguội'
    },
    {
      key: 3,
      icon: <IconCardLinkSupportService />,
      link: '',
      onClick: () => {
        setIsOpenSupportCenterPopup(true)
      },
      text: 'Yêu cầu hỗ trợ'
    }
  ]
  return (
    <div>
      <BaseTitle>Hỗ trợ</BaseTitle>
      <div className="CardIconsLinkSupport">
        {icons.map((item) => {
          if (item.link) {
            return (
              <a
                key={item.key}
                className="CardIconsLinkSupport_item"
                href={item.link}
                target={item.target}
                rel={item.target === '_blank' ? 'noreferrer' : undefined}>
                <div className="CardIconsLinkSupport_item_icon">{item.icon}</div>
                <div className="CardIconsLinkSupport_item_text">{item.text}</div>
              </a>
            )
          }

          return (
            <button key={item.key} type="button" className="CardIconsLinkSupport_item" onClick={item.onClick}>
              <div className="CardIconsLinkSupport_item_icon">{item.icon}</div>
              <div className="CardIconsLinkSupport_item_text">{item.text}</div>
            </button>
          )
        })}
      </div>
      <SupportCenterPopup open={isOpenSupportCenterPopup} onClose={() => setIsOpenSupportCenterPopup(false)} />

      <BaseBottomSheetPopup open={isOpenPunishPopup} onClose={() => setIsOpenPunishPopup(false)} title="Nộp phạt nguội">
        <div className="CardIconsLinkSupport_punishPopupContent">
          <div className="CardIconsLinkSupport_punishPopupContent_icon">
            <IconNopPhatNguoi />
          </div>
          <div className="CardIconsLinkSupport_punishPopupContent_text">
            Bạn vui lòng truy cập vào trang web Cổng Dịch vụ công Quốc gia hoặc đến trực tiếp Cơ quan Công an để nộp phạt nguội.
          </div>
        </div>
      </BaseBottomSheetPopup>
    </div>
  )
}
